import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "dialog-content",
  templateUrl: "./dialog-content.component.html",
  styleUrls: ["./dialog-content.component.scss"],
})
export class DialogContentComponent {
  @Input() dialogContent: DialogContentMetadata = null;
  @Output() onConfirmation: EventEmitter<boolean> = new EventEmitter<boolean>();

  public get dialogType(): typeof DialogType {
    return DialogType; //nosonar
  }

  constructor() {}

  public onCancel() {
    this.onConfirmEmit(false);
  }

  public onConfirm() {
    this.onConfirmEmit(true);
  }
  private onConfirmEmit(value){
    if (this.onConfirmation) {
      this.onConfirmation.emit(value);
    }
  }
}

export interface DialogContentMetadata {
  heading: string;
  subHeading: string;
  imageUrl?: string;
  type: DialogType;
  warningSection?: string;
  primaryButtonText: string;
  secondaryButtonText?: string;
  hasFooter?: boolean;
}

export enum DialogType {
  Message,
  Confirmation,
  AlertConfirmation,
}
